<template>
  <v-container>
      <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <!--プライバシーポリシー-->
    <Content></Content>
  </v-container>
</template>

<script>
// プライバシーポリシーコンポーネントをインポート
import Content from '../components/Privacy/Content'

export default {
  name: 'Privacy',
  components: {
    Content
  }
}
</script>
<script>
import Content from '../components/Privacy/Content'
export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
     {
        name: '個人情報保護方針',
        href: 'Privacy'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Content
  }
}
</script>
